import clsx from "clsx";
import Link from "next/link";
import MaxWidthWrapper from "components/Tiles/commonComponents/MaxWidthWrapper";
import { ButtonVariantTypes, getButtonVariantStylesAndSize } from "components/ui/button";
import OptionSection from "./sections";
type OptionProps = {
  sections: {
    title: string;
    subTitle?: string;
    body: string;
    image: string;
    link?: string;
    keyPoints?: string[]; // New prop for key points
    bgColor?: string;
  }[];
  title?: string;
  subTitle?: string;
  body?: string;
  ctaUrl?: string;
  bgColor?: string;
  wrapperClass?: string;
  ctaText?: string;
  position?: "left" | "center" | "right";
};

// Tailwind classes for dynamic content: py-14 py-16 py-20 py-24 py-28 py-32 pb-40 pt-24 pb-12 pb-14 pb-16 pb-20  py-36 py-40 py-44 py-48

const Options = ({
  sections,
  title,
  ctaText,
  bgColor,
  wrapperClass,
  ctaUrl,
  subTitle,
  body,
  position = "center"
}: OptionProps) => {
  return (
    <section
      id="Options-102"
      style={{
        backgroundColor: bgColor
      }}
    >
      <MaxWidthWrapper className={wrapperClass}>
        <section className="w-full px-0 pb-4 pt-10">
          {(!!title || !!subTitle || !!body) && (
            <div
              className={clsx("flex flex-col px-6 pt-10 md:px-0", {
                ["items-center text-center"]: !position || position === "center",
                ["items-start text-left"]: position === "left",
                ["items-end text-right"]: position === "right"
              })}
            >
              {subTitle ? <p className="subby text-center"> {subTitle}</p> : null}
              {title ? <h2 className="tile-main-header">{title}</h2> : null}
              {body ? <p className="tile-subtitle">{body}</p> : null}

              {ctaUrl && (
                <div className="mb-2 mt-6 text-center">
                  <Link
                    href={ctaUrl}
                    prefetch={false}
                    className={getButtonVariantStylesAndSize({ variant: ButtonVariantTypes.BRAND, size: "xl" })}
                  >
                    {ctaText}
                  </Link>
                </div>
              )}
            </div>
          )}
          <div
            className={clsx("mt-6 grid grid-cols-1 gap-4 gap-x-12 sm:mt-12 sm:flex-row sm:justify-between sm:pt-2", {
              "lg:grid-cols-1": sections?.length === 1,
              "lg:grid-cols-2": sections?.length === 2,
              "lg:grid-cols-3": sections?.length === 3
            })}
          >
            {sections?.map((section, index) => (
              <OptionSection
                key={index}
                link={section.link}
                body={section.body}
                title={section.title}
                bgColor={section.bgColor}
                subTitle={section?.subTitle}
                image={section.image}
                position={position}
                keyPoints={section.keyPoints} // Passing keyPoints to OptionSection
              />
            ))}
          </div>
        </section>
      </MaxWidthWrapper>
    </section>
  );
};

export default Options;
